import { getListUserApi, createUserApi, updateUserApi, getDetailUserApi, deleteUserApi, changePasswordApi } from '@/api/user/index'

const state = {
  user: {},
  users: {
    pagination: {},
    list: []
  }
}

const getters = {
  getListUser: (state) => {
    if (state.users.list.length !== 0) {
      return state.users.list
    }
    return []
  },
  getPaginationUser: (state) => {
    if (state.users.pagination) {
      return state.users.pagination
    }
    return {}
  },
  getDetailUser: (state) => {
    return state.user
  }
}

const mutations = {
  SET_LIST_USER: (state, listUser) => {
    const {data, ...pagination} = listUser
    state.users = {pagination: pagination.meta, list: data}
  },
  SET_DETAIL_USER: (state, user) => {
    state.user = user
  }
}

const actions = {
  async getListUserAction ({commit}, params) {
    try {
      const response = await getListUserApi(params)
      commit('SET_LIST_USER', response.data)
      return response
    } catch (e) {
      return e
    }
  },
  async getDetailUserAction ({commit}, params) {
    try {
      const response = await getDetailUserApi(params)
      commit('SET_DETAIL_USER', response.data)
      return response
    } catch (e) {
      return e
    }
  },
  async createUserAction ({commit}, params) {
    try {
      return await createUserApi(params)
    } catch (error) {
      return error
    }
  },
  async updateUserAction ({commit}, params) {
    try {
      return await updateUserApi(params)
    } catch (error) {
      return error
    }
  },
  async deleteUserAction ({commit}, params) {
    try {
      return await deleteUserApi(params)
    } catch (error) {
      return error
    }
  },
  async changePasswordAction ({commit}, params) {
    try {
      return await changePasswordApi(params)
    } catch (error) {
      return error
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js